import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const KPICard = ({ title, subtitle, value, change, changeLabel, currency, icon: Icon, iconElement, color, forecast }) => {
  const currencySymbol = currency || '€';
  const isPositive = change > 0;
  const isNegative = change < 0;

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString('fr-FR', { minimumFractionDigits: 2 });
    }
    return val;
  };

  let changeColor = 'text-muted-foreground';
  if (isPositive) changeColor = 'text-red-500';
  if (isNegative) changeColor = 'text-emerald-500';

  return (
    <Card className="hover:border-primary/30 transition-colors" data-testid="kpi-card">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <div>
              <p className="text-sm text-muted-foreground font-medium">{title}</p>
              {subtitle && <p className="text-xs text-muted-foreground/60 -mt-0.5">{subtitle}</p>}
            </div>
            <p className="text-2xl font-semibold font-[Outfit] tracking-tight">
              {formatValue(value)}
              <span className="text-lg ml-1">{currencySymbol}</span>
            </p>
            {change != null && (
              <div className={'flex items-center gap-1 text-sm font-medium ' + changeColor}>
                {isPositive && <TrendingUp className="w-4 h-4" />}
                {isNegative && <TrendingDown className="w-4 h-4" />}
                {!isPositive && !isNegative && <Minus className="w-4 h-4" />}
                <span>{isPositive ? '+' : ''}{change}% {changeLabel || 'vs mois précédent'}</span>
              </div>
            )}
            {forecast > 0 && (
              <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1">
                <TrendingUp className="w-3 h-3" />
                <span>Prév. fin de mois : {formatValue(forecast)} {currencySymbol}</span>
              </div>
            )}
          </div>
          {(Icon || iconElement) && (
            <div className={'w-12 h-12 rounded-xl flex items-center justify-center ' + (color || 'bg-primary/10')}>
              {iconElement || <Icon className="w-6 h-6" />}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
